import React, { useEffect, useState } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Alert } from '@mui/material';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export default function AdminHubspotOwnersModule() {
  const [owners, setOwners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    axios.get(`${API_BASE_URL}/api/hubspot-owners`)
      .then(res => setOwners(res.data))
      .catch(() => setError('Failed to fetch HubSpot owners'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
        HubSpot Users & Owner IDs
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, color: 'gray' }}>
        <b>Owner ID</b> is used when assigning ownership of tasks or records. <b>User ID</b> is for settings API only.
      </Typography>
      {loading && <CircularProgress />}
      {error && <Alert severity="error">{error}</Alert>}
      {!loading && !error && (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><b>Owner ID<br/>(assign to records)</b></TableCell>
                <TableCell><b>User ID<br/>(settings API only)</b></TableCell>
                <TableCell><b>Name</b></TableCell>
                <TableCell><b>Email</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {owners.map(owner => (
                <TableRow key={owner.ownerId}>
                  <TableCell>{owner.ownerId}</TableCell>
                  <TableCell>{owner.userId}</TableCell>
                  <TableCell>{owner.firstName} {owner.lastName}</TableCell>
                  <TableCell>{owner.email}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
